import React, { useState, useEffect, useRef } from "react";
import { ScrollbarWrapper } from "../../../../../../components/ScrollbarWrapper";

const TimePicker = ({ name, label, value, disabled, onChange, required, error, hint }) => {
    const hours = [];
    const minutes = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"];
    const [timeValue, setTimeValue] = useState(value);
    const [timePickerOpen, isTimePickerOpen] = useState(false);
    const [hour, setHour] = useState("1");
    const [minute, setMinute] = useState("00");
    const [ampm, setAmpm] = useState("");
    const [isHourSelected, SetIsHourSelected] = useState(false);
    const [isMinuteSelected, SetIsMinuteSelected] = useState(false);
    const [isAmpmSelected, SetIsAmpmSelected] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const selectRef = useRef(null);

    for (let i = 0; i < 12; i++) {
        hours[i] = `${i + 1}`;
    }

    const handleSelectedHour = (id) => {
        SetIsHourSelected(id);
    };

    const handleSelectedMinute = (id) => {
        SetIsMinuteSelected(id);
    };

    const handleSelectedAmpm = (id) => {
        SetIsAmpmSelected(id);
    };

    const extractTime = (time) => {
        let [hour, minute] = time.split(":").map(Number);
        let ampm = "AM";

        if (hour === 0) {
            hour = 12;
            ampm = "AM";
        } else if (hour === 12) {
            ampm = "PM";
        } else if (hour > 12) {
            hour -= 12;
            ampm = "PM";
        }

        const hourStr = hour.toString().padStart(2, "0");
        const minuteStr = minute.toString().padStart(2, "0");

        setHour(hourStr);
        setMinute(minuteStr);
        setAmpm(ampm);
        SetIsHourSelected(hourStr);
        SetIsMinuteSelected(minuteStr);
        SetIsAmpmSelected(ampm);
    };

    const timePickerToggle = () => {
        isTimePickerOpen(!timePickerOpen);
    };

    const handleTimeChange = (hour, minute, ampm) => {
        setHour(hour);
        setMinute(minute);
        setAmpm(ampm);
        setTimeValue(`${hour}:${minute}`);

        let hour24 = Number(hour);
        if (ampm === "AM") {
            if (hour24 === 12) hour24 = 0;
        } else {
            if (hour24 !== 12) hour24 += 12;
        }

        const hourStr = hour24.toString().padStart(2, "0");
        onChange({ target: { name, value: `${hourStr}:${minute}` } });
    };

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            isTimePickerOpen(false);
        }
    };

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        return value === "" ? extractTime("1:00") : extractTime(value);
    }, [value]);

    useEffect(() => {
        handleSelectedHour(hour);
        document.addEventListener("mousedown", handleClickOutside);
        window.addEventListener("resize", handleResize);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <>
            <label htmlFor={`input-${name}`} className={`${required ? "input-required" : ""}`}>
                {label}
            </label>
            <div className={`dropdown dropdown--select dropdown--select--timepicker ${disabled ? "timepicker-disabled" : ""}`} ref={selectRef}>
                <i className="fa-light fa-clock"></i>
                <div className="dropdown__toggle" onClick={() => !disabled && timePickerToggle()}>
                    {value === "" ? (
                        ""
                    ) : (
                        <span>
                            {hour} : {minute} {ampm}
                        </span>
                    )}
                </div>
                <div className={`dropdown__menu ${timePickerOpen ? "active" : ""}`}>
                    <ScrollbarWrapper
                        id="mainContentScrollbar"
                        className="dropdown__menu__wrap time-picker-hours-scroll-snap"
                        options={{
                            removeXTrack: true,
                        }}
                    >
                        <div className="timepicker-column timepicker-hours">
                            <div className="dropdown__menu__item disabled">h</div>
                            {hours.map((hour) => (
                                <div
                                    className={`dropdown__menu__item ${isHourSelected === hour ? "selected" : ""}`}
                                    data-value={hour}
                                    onClick={() => {
                                        if (disabled) return;
                                        handleTimeChange(hour, minute, ampm);
                                        handleSelectedHour(hour);
                                    }}
                                >
                                    {hour}
                                </div>
                            ))}
                            <div className="dropdown__menu__item disabled">h</div>
                        </div>
                    </ScrollbarWrapper>
                    <ScrollbarWrapper
                        id="mainContentScrollbar"
                        className="dropdown__menu__wrap time-picker-minutes-scroll-snap"
                        options={{
                            removeXTrack: true,
                        }}
                    >
                        <div className="timepicker-column timepicker-minutes">
                            <div className="dropdown__menu__item disabled">m</div>
                            {minutes.map((minute) => (
                                <div
                                    className={`dropdown__menu__item ${isMinuteSelected === minute ? "selected" : ""}`}
                                    data-value={minute}
                                    onClick={() => {
                                        if (disabled) return;
                                        handleTimeChange(hour, minute, ampm);
                                        handleSelectedMinute(minute);
                                    }}
                                >
                                    {minute}
                                </div>
                            ))}
                            <div className="dropdown__menu__item disabled">m</div>
                        </div>
                    </ScrollbarWrapper>
                    <ScrollbarWrapper
                        id="mainContentScrollbar"
                        className="dropdown__menu__wrap time-picker-ampm-scroll-snap"
                        options={{
                            removeXTrack: true,
                        }}
                    >
                        <div className="timepicker-column timepicker-ampm">
                            <div className="dropdown__menu__item disabled">
                                <i className="fa-regular fa-sun-bright"></i>
                            </div>
                            <div
                                className={`dropdown__menu__item ${isAmpmSelected === "AM" ? "selected" : ""}`}
                                data-value="AM"
                                onClick={() => {
                                    if (disabled) return;
                                    handleTimeChange(hour, minute, "AM");
                                    handleSelectedAmpm("AM");
                                }}
                            >
                                AM
                            </div>
                            <div
                                className={`dropdown__menu__item ${isAmpmSelected === "PM" ? "selected" : ""}`}
                                data-value="PM"
                                onClick={() => {
                                    if (disabled) return;
                                    handleTimeChange(hour, minute, "PM");
                                    handleSelectedAmpm("PM");
                                }}
                            >
                                PM
                            </div>
                            <div className="dropdown__menu__item disabled">
                                <i className="fa-regular fa-moon"></i>
                            </div>
                        </div>
                    </ScrollbarWrapper>
                </div>
            </div>

            {/* <input
                type="text"
                name={name}
                id={`input-${name}`}
                value={value}
                onChange={onChange}
                className={`input-disabled ${disabled ? "inactive" : ""} `}
                disabled={disabled}
            /> */}
            {hint && <div className="hint-message-text">{hint}</div>}
            {error && <div className="error-message-text">{error}</div>}
        </>
    );
};

export default TimePicker;
